import { Injectable, Provider } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
  NativeDateAdapter,
} from '@angular/material/core';

const GERMAN_DATE = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const DE_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};

@Injectable()
export class DeDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value !== 'string') {
      return super.parse(value, parseFormat);
    }
    const text = value.trim();
    if (!text) {
      return null;
    }
    const german = GERMAN_DATE.exec(text);
    if (german) {
      return this.plausibleDate(Number(german[3]), Number(german[2]), Number(german[1]));
    }
    const iso = ISO_DATE.exec(text);
    if (iso) {
      return this.plausibleDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
    }
    return this.invalid();
  }

  // new Date() rolls 31.02. silently over to 3 March; the round trip exposes that.
  private plausibleDate(year: number, month: number, day: number): Date {
    const date = new Date(year, month - 1, day);
    const matches = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    return matches ? date : this.invalid();
  }
}

export function provideDeDateAdapter(): Provider[] {
  return [
    { provide: DateAdapter, useClass: DeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DE_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
  ];
}
